import MultiSelectWithSearch from 'components/common/MiltiSelectSearch'
import './filters.scss'
import { Select } from 'antd'
interface FilterFieldsProps {
    currentFilters: any
    localFilters: any
    handleFilterChange: (fieldName: string, value: any) => void
    numbersOptions: string[]
    queuesOptions: string[]
    agentsOptions: { label: string; value: string }[]
}

export function FilterFields({ currentFilters, localFilters, handleFilterChange, numbersOptions, queuesOptions, agentsOptions }: FilterFieldsProps) {
    return (
        <>
            {Object.prototype.hasOwnProperty.call(currentFilters || {}, 'selectedAgent') && (
                <div className="filter-field">
                    <div className="label">Agents</div>
                    <MultiSelectWithSearch
                        className="call-center-multisearch"
                        placeholder="Select Agents"
                        value={localFilters.selectedAgent || []}
                        onChange={(value) => handleFilterChange('selectedAgent', value)}
                        options={agentsOptions}
                    />
                </div>
            )}

            <div className="filter-field">
                <div className="label">Queue</div>
                <MultiSelectWithSearch
                    className="call-center-multisearch"
                    placeholder="Select Queue"
                    value={localFilters.selectedQueue || []}
                    onChange={(value) => handleFilterChange('selectedQueue', value)}
                    options={queuesOptions?.map((queue) => ({ label: queue, value: queue }))}
                />
            </div>

            <div className="filter-field">
                <div className="label">Number</div>
                <MultiSelectWithSearch
                    className="call-center-multisearch"
                    placeholder="Select Number"
                    value={localFilters.selectedNumber || []}
                    onChange={(value) => handleFilterChange('selectedNumber', value)}
                    options={numbersOptions?.map((number) => ({ label: number, value: number }))}
                />
            </div>

            <div className="filter-field">
                <div className="label">Call Duration</div>
                <Select
                    allowClear
                    placeholder="Duration Range"
                    value={localFilters.selectedDuration}
                    onChange={(value) => handleFilterChange('selectedDuration', value)}
                    options={[
                        { label: 'Less than 1 min', value: 'lt1' },
                        { label: '1–5 mins', value: '1to5' },
                        { label: '5–15 mins', value: '5to15' },
                        { label: 'More than 15 mins', value: 'gt15' },
                    ]}
                    className="filter-select"
                    style={{ width: '100%' }}
                />
            </div>
        </>
    )
}
